import { InputProps, Input as ChakraInput, useTheme } from "@chakra-ui/react";
import { Theme } from "../theme";

export type CSSProperties = React.CSSProperties | Record<string, React.CSSProperties>

const Input = (
    props: InputProps & {
        height?: string;
        name?: string;
        size?: string;
        disabled?: boolean;
    }
) => {
    const { variant, size, name, disabled = false, height } = props;
    const theme = useTheme<Theme>();
    const baseStyle: React.CSSProperties = {
        height: height ? height : "3.25rem",
        border: "1px solid",
        borderColor: theme.colors.secondary.main,
        borderRadius: "0.25rem",
        fontFamily: "body",
        fontSize: theme.fontSizes.body,
        marginBottom: theme.space.xs,
        // "&::placeholder": {
        //   color: "#e3e5e6"
        // }
    };

    const variantOutline: CSSProperties = {
        ...baseStyle,
        "&:hover": {
            borderColor: theme.colors.secondary.main,
        },
        "&:focus": {
            // backgroundColor: theme.colors.bg.main,
        },
        "&:focus-visible": {
            borderColor: theme.colors.secondary.main,
            boxShadow: "none",
        },
    };

    const variantTransparent: CSSProperties = {
        ...baseStyle,
        border: "none",
        background: "transparent",
        "&:hover": {
            borderColor: theme.colors.secondary.main,
        },
        "&:focus-visible": {
            borderColor: theme.colors.secondary.main,
            boxShadow: "none",
        },
    };

    const sizes: { [key: string]: string } = {
        sm: "20px",
        md: "30px",
        default: "52px",
        contain: "100%",
    };

    const style: React.CSSProperties = {
        ...(variant === "outline" && variantOutline),
        ...(variant === "transparent" && variantTransparent),
        ...(size && {
            height: sizes[size],
        }),
    };
    return <ChakraInput disabled={disabled} {...props} sx={style}></ChakraInput>;
};

export default Input;